__turbopack_context__.v({
  "asterisk": "Select-module-scss-module__A-2qOq__asterisk",
  "book-creator": "Select-module-scss-module__A-2qOq__book-creator",
  "container": "Select-module-scss-module__A-2qOq__container",
  "content": "Select-module-scss-module__A-2qOq__content",
  "disabled": "Select-module-scss-module__A-2qOq__disabled",
  "error": "Select-module-scss-module__A-2qOq__error",
  "final": "Select-module-scss-module__A-2qOq__final",
  "first": "Select-module-scss-module__A-2qOq__first",
  "group": "Select-module-scss-module__A-2qOq__group",
  "grouped": "Select-module-scss-module__A-2qOq__grouped",
  "icon": "Select-module-scss-module__A-2qOq__icon",
  "item": "Select-module-scss-module__A-2qOq__item",
  "label": "Select-module-scss-module__A-2qOq__label",
  "label-hidden": "Select-module-scss-module__A-2qOq__label-hidden",
  "option": "Select-module-scss-module__A-2qOq__option",
  "primary": "Select-module-scss-module__A-2qOq__primary",
  "primary-outlined": "Select-module-scss-module__A-2qOq__primary-outlined",
  "radio": "Select-module-scss-module__A-2qOq__radio",
  "rounded": "Select-module-scss-module__A-2qOq__rounded",
  "scroll": "Select-module-scss-module__A-2qOq__scroll",
  "selected": "Select-module-scss-module__A-2qOq__selected",
  "signup-flow": "Select-module-scss-module__A-2qOq__signup-flow",
  "square": "Select-module-scss-module__A-2qOq__square",
  "sub-text": "Select-module-scss-module__A-2qOq__sub-text",
  "text": "Select-module-scss-module__A-2qOq__text",
  "tonal": "Select-module-scss-module__A-2qOq__tonal",
  "tonal-outlined": "Select-module-scss-module__A-2qOq__tonal-outlined",
  "trigger": "Select-module-scss-module__A-2qOq__trigger",
  "trigger-icon": "Select-module-scss-module__A-2qOq__trigger-icon",
});
